<template>
  <el-dialog title="确认核单" :visible.sync="dialogFormVisible" width="900px">
    <p class="sn">订单号：{{ sn }}</p>

    <Table :data="list" :columns="columns" :loading="listLoading">
      <template v-slot:trip_type>
        <el-table-column label="订单类型" width="70" align="center">
          <template slot-scope="scope"> {{ ['', '拼团', '包团'][scope.row.trip_type] }} </template>
        </el-table-column>
      </template>
      <template v-slot:source>
        <el-table-column label="订单来源" width="70" align="center">
          <template slot-scope="scope">
            {{ $platform[scope.row.source] }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:contact>
        <el-table-column label="联系人" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.contact.name }} <br />
            {{ scope.row.contact.mobile }}</template
          >
        </el-table-column>
      </template>
      <template v-slot:guide>
        <el-table-column label="接单导游" width="100" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.guide">
              {{ scope.row.guide.name }}<br />{{ scope.row.guide.mobile }}
            </p>
          </template>
        </el-table-column>
      </template>
      <template v-slot:action>
        <el-table-column label="操作" minWidth="100" align="center" fixed="right">
          <template slot-scope="scope"
            ><el-input-number
              v-if="can_consume"
              v-model="scope.row.use_user_num"
              :min="0"
              :max="scope.row.user_num"
              size="mini"
              style="width: 100px"
              @change="handleChange"
            />
            <p v-else>
              不可核验<br />
              未到使用日期
            </p>
          </template>
        </el-table-column>
      </template>
    </Table>
    <div slot="footer" class="dialog-footer" v-if="can_consume">
      <el-button type="primary" @click="saveData" v-model="use_user_num">核验</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDetail, consume } from '@/api/orders'

export default {
  name: 'Consume',
  data() {
    return {
      list: null,
      listLoading: true,
      columns: [
        {
          label: '产品名称',
          width: '120',
          prop: 'product_name',
          showOverflowTooltip: true
        },
        {
          label: '套餐名称',
          width: '100',
          prop: 'package_name',
          showOverflowTooltip: true
        },
        {
          label: '订单类型',
          slot: 'trip_type'
        },
        {
          label: '订单来源',
          slot: 'source'
        },
        {
          label: '出发日期',
          width: '90',
          prop: 'use_date',
          align: 'center'
        },
        {
          label: '联系人',
          slot: 'contact'
        },
        {
          label: '接单导游',
          slot: 'guide'
        },
        {
          label: '数量',
          width: '60',
          prop: 'user_num',
          align: 'center'
        },
        {
          label: '操作',
          slot: 'action'
        }
      ],
      dialogFormVisible: false,
      sn: '',
      can_consume: false,
      use_user_num: 1
    }
  },
  methods: {
    /**
     * @description: 详情
     * @param {*} sn
     * @return {*}
     */
    handleConsume(sn, can_consume) {
      this.can_consume = can_consume
      getDetail(sn).then((res) => {
        this.sn = sn
        this.list = [].concat({ ...res.data, use_user_num: res.data.user_num })
        this.use_user_num = res.data.user_num
        this.dialogFormVisible = true
        this.listLoading = false
      })
    },
    /**
     * @description: 核单
     * @return {*}
     */
    saveData() {
      const _this = this
      consume(this.sn, { use_user_num: _this.use_user_num }).then(() => {
        this.$parent.fetchData()
        this.dialogFormVisible = false
        this.$parent.$notify({
          title: '成功',
          message: '核单成功',
          type: 'success'
        })
      })
    },
    handleChange(value) {
      console.log('value', value)
      this.use_user_num = value
    }
  }
}
</script>
<style scoped lang="less">
.sn {
  margin-bottom: 10px;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  .el-button {
    width: 120px;
    letter-spacing: 2px;
    font-weight: 600;
  }
}
</style>
